<div class="page gray-font-color font-family">
  <div class="header-navigation-back">
    <div class="back-icon" (click)="backAction()">
      <mat-icon svgIcon="left-arrow"></mat-icon>
    </div>
    <div class="title">FleetOperate Support</div>
  </div>
  <div class="help-section content">
    <h3>Need help?</h3>

    <div class="help-notice">
      <p class="help-notice-text">
        For questions related to your <strong>DQF, hiring decisions, or any carrier-specific requirements</strong>, please reach out directly to your carrier company.
      </p>
      <p class="help-notice-text">
        <strong>FleetOperate</strong> is a software platform provider. If you are experiencing any <strong>technical issues</strong> with the app, we're happy to help — feel free to contact us using the options below.
      </p>
    </div>

    <a class="help-card" href="tel:+12264068444">
      <div class="icon-container phone-icon">
        <mat-icon svgIcon="customer-phone"></mat-icon>
      </div>
      <div class="help-text">
        <div class="help-label"><strong>Call Us At:</strong> +1 226-406-8444</div>
      </div>
    </a>

    <a class="help-card" href="https://wa.me/16472544929" target="_blank">
      <div class="icon-container whatsapp-icon">
        <mat-icon svgIcon="customer-whatsapp"></mat-icon>
      </div>
      <div class="help-text">
        <div class="help-label"><strong>WhatsApp Us:</strong> +1 647-254-4929</div>
      </div>
    </a>

    <a class="help-card" href="mailto:support@fleetoperate.com">
      <div class="icon-container email-icon">
        <mat-icon svgIcon="customer-email"></mat-icon>
      </div>
      <div class="help-text">
        <div class="help-label"><strong>Email:</strong> support&#64;fleetoperate.com</div>
      </div>
    </a>
  </div>
</div>
